'use client';

import { LiFiWidget, WidgetConfig, useWidgetEvents, WidgetEvent, ChainTokenSelected } from '@lifi/widget';
import { useEffect, useState } from 'react';
import { BridgeWallet } from 'mode-shared/components/bridge/BridgeWallet';
import { usePrivy } from 'mode-shared/context/WalletConnectorContext';
import { SOLANA_CHAIN_ID } from 'mode-shared/context/SolanaContext/SolanaWalletProvider';

const widgetConfig: WidgetConfig = {
  theme: {
    container: {
      borderRadius: '16px',
    },
    palette: {
      background: {
        default: '#151617',
        paper: '#2B2B2B',
      },
      primary: {
        main: '#DFFE00', // yellow
      },
      secondary: {
        main: '#2B2B2B', // grey
      },
      text: {
        primary: '#F8F8F8',
        secondary: '#F8F8F8',
      },
      grey: {
        800: '#5E5E5E',
      },
    },
    typography: {
      fontFamily: 'var(--font-ibm-sans)',
    },
  },
  chains: {
    allow: [34443, 1, 10, 42161, 8453, 137, 81457, 43114, 534352, 56, SOLANA_CHAIN_ID], // 17000 holesky is not supported by Li.fi
  },
  integrator: 'Mode',
  // // set source chain to Arbitrum
  fromChain: 42161,
  // // // set destination chain to Optimism
  toChain: 34443,
  // // // set source token to USDC (Arbitrum)
  fromToken: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  // // // set source token to USDC (Mode)
  toToken: '0xd988097fb8612cc24eeC14542bC03424c656005f',
};

export const BridgeWidget = () => {
  const { connectWallet } = usePrivy();

  const handleConnect = () => {
    connectWallet();
  };
  const [selectedChain, setSelectedChain] = useState<number>();
  const widgetEvents = useWidgetEvents();

  useEffect(() => {
    widgetEvents.on(WidgetEvent.SourceChainTokenSelected, (param: ChainTokenSelected) => {
      setSelectedChain(param.chainId);
    });

    return () => widgetEvents.all.clear();
  }, [widgetEvents]);

  return (
    <div className="flex flex-col gap-y-4">
      <BridgeWallet selectedChainId={selectedChain} />
      <LiFiWidget
        integrator="Mode"
        config={{
          ...widgetConfig,
          walletConfig: {
            onConnect: handleConnect,
          },
        }}
      />
    </div>
  );
};
